import * as ActionTypes from '../constants/ActionTypes';
import { ActionCreator } from '../utils/flux';

/**
 * @class ServerResponseActions
 * @extends ActionCreator
 */
export default class ServerResponseActions extends ActionCreator {
    /**
     * @param {object} times
     */
    receiveTimes(times, isExistingPatient) {
        this.dispatch({
            actionType: ActionTypes.RECEIVE_TIMES,
            isExistingPatient,
            times,
        });
    }
}
